export default "__VITE_ASSET__R4CGOQcm__"